import gql from "graphql-tag";

export default gql`
  mutation deleteCustomer($customerId: ID) {
    deleteCustomer(customerId: $customerId) {
      id
    }
  }
`;
